export default "__VITE_ASSET__DZKcFyVh__"